const Paths = {
  home: "/second",
  add: "/add-product",
  edit: "/edit",
  sell: "/sell",
  cart: "/cart",
};

export default Paths;